var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"vid":_vm.vid,"name":_vm.name,"rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
var field = ref.field;
return [_c('v-text-field',{attrs:{"type":"number","label":_vm.name,"value":_vm.innerValue,"error-messages":errors,"prefix":"€","disabled":_vm.disabled},on:{"change":function (value) { return (_vm.innerValue = _vm.$functions.validateInputPrice(value, _vm.vid)); }}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }